export function getQueryParam(rawParam: string | string[] | undefined) {
  return Array.isArray(rawParam) ? rawParam[0] : rawParam;
}
